// extracted by mini-css-extract-plugin
export default {"maintenanceOrder":"styles_maintenanceOrder__SdR2Z","success":"styles_success__NV7aW","loading":"styles_loading__etb7d","error":"styles_error__az5lO"};